<template>
  <div class="shipmentsOrder">
    <div class="header">
      <el-tabs :value="tabPaneValue" @tab-click="tabPaneClick">
        <el-tab-pane label="发货工单" name="first">
          <span class="activeLink">发货工单</span>
          <div class="btnBox">
            <div class="searchBtnBox" style="margin-right:15px">
              <el-tooltip class="item" content="只看我的工单" placement="bottom" :open-delay="300">
                <el-checkbox v-model="searchConditionForm.onlyMy" @change="onlyMyChange">我的工单</el-checkbox>
              </el-tooltip>
            </div>
            <div class="searchBtnBox" v-if="isMoreSearch">
              <el-tooltip
                class="item"
                content="清除查询条件"
                placement="bottom"
                :open-delay="300"
              >
                <el-button
                  icon="iconfont icon-qingkong"
                  size="small"
                  class="cleanBox"
                  @click="onClear"
                ></el-button>
              </el-tooltip>
              <el-button
                type="primary"
                icon="el-icon-search"
                size="small"
                @click="onSearch"
                >查询</el-button
              >
            </div>
            <el-button
              type="primary"
              icon="el-icon-plus"
              size="small"
              @click="addNewBtn"
              >新建</el-button
            >
            <el-tooltip
              class="item"
              content="查询条件"
              placement="bottom"
              :open-delay="300"
            >
              <el-button
                class="btn_more"
                :class="{ activeUserMore: isMoreSearch }"
                size="small"
                icon="el-icon-d-arrow-right"
                @click="moreSearchBtn"
              ></el-button>
            </el-tooltip>
          </div>
        </el-tab-pane>
        <el-tab-pane
          v-for="(item, index) in tabPaneList"
          :key="item.id"
          :label="item.orderNumber"
          :name="item.id"
        >
          <span slot="label">
            {{ item.orderNumber }}
            <i
              class="el-icon-circle-close"
              @click.stop="closeTabPane(index)"
            ></i>
          </span>
          <span
            class="childTabs"
            :class="{ activeLink: cutDetail == 'detail' }"
            @click="cutDetailChange('detail')"
            >工单详情</span
          >
          <span
            class="childTabs"
            :class="{ activeLink: cutDetail == 'devices' }"
            @click="cutDetailChange('devices')"
            >产品列表</span
          >          
          <div class="btnBox" v-if="cutDetail == 'detail'">
            <!-- 需要上传DPK -->
            <div class="searchBtnBox" v-if="tabPaneData.dpkStatus">
              <el-button v-if="tabPaneData.dpkStatus.code=='WAITING_UPLOAD' || tabPaneData.dpkStatus.code=='UNKNOW'"
                type="primary" size="small" @click="uploadSubmitDpkBtn">Submit CBR</el-button>
              <el-button v-if="tabPaneData.dpkStatus.code=='UPLOADED' || tabPaneData.dpkStatus.code=='SUBMITTED'"
                type="primary" size="small" @click="uploadCompletDpkBtn">Complete CBR</el-button>
              <!-- 待上传CBR的不能发货 -->
              <el-button v-if="tabPaneData.dpkStatus.code=='WAITING_UPLOAD'" disabled content="请先上传CRB后再发货"
                type="primary" size="small" style="margin-right: -20px">发货</el-button>
              <el-button v-if="tabPaneData.dpkStatus.code!='WAITING_UPLOAD' && tabPaneData.status && (tabPaneData.status.code == 'WAIT_SHIPMENT' || tabPaneData.status.code == 'CANCEL_SHIPMENT')"
                type="primary" size="small" @click="exWarehouseBtn" style="margin-right: -20px"
                >发货</el-button>
              <el-button v-if="tabPaneData.status && tabPaneData.status.code == 'EX_WAREHOUSE'"
                type="primary" size="small" @click="rollbackExWarehouseBtn($event, tabPaneData)" style="margin-right: -20px"
                >取消发货</el-button>
            </div>
            <!-- 不需要上传DPK -->
            <div class="searchBtnBox" v-else>
              <el-button v-if="tabPaneData.status && (tabPaneData.status.code == 'WAIT_SHIPMENT' || tabPaneData.status.code == 'CANCEL_SHIPMENT')"
                type="primary" size="small" @click="exWarehouseBtn" style="margin-right: -20px"
                >发货</el-button>
              <el-button v-if="tabPaneData.status && tabPaneData.status.code == 'EX_WAREHOUSE'"
                type="primary" size="small" @click="rollbackExWarehouseBtn($event, tabPaneData)" style="margin-right: -20px"
                >取消发货</el-button>
            </div>
          </div>
          <div class="btnBox" v-if="cutDetail == 'devices'">
            <div class="searchBtnBox">
              <el-button type="primary" size="small" @click="rework">
                返工
              </el-button>
              <el-button v-if="tabPaneData.status && tabPaneData.status.code == 'WAIT_SHIPMENT'"
                type="primary"
                size="small"
                @click="exWarehouseBtn"
                >发货</el-button
              >
              <el-dropdown trigger="click" @command="devicesDownloadBtn">
                <el-button
                  class="downIcon"
                  type="primary"
                  icon="el-icon-d-arrow-right"
                  size="small"
                  >导出</el-button
                >
                <el-dropdown-menu slot="dropdown" class="devicesDownloadDrop">
                  <el-dropdown-item command="箱标" v-if="tabPaneData.status && tabPaneData.status.code == 'WAIT_SHIPMENT'">箱标</el-dropdown-item>
                  <el-dropdown-item command="栈板标" v-if="tabPaneData.status && tabPaneData.status.code == 'WAIT_SHIPMENT'">栈板标</el-dropdown-item>
                  <el-dropdown-item command="发货单报表">发货单报表</el-dropdown-item>
                  <el-dropdown-item command="发货单报表2" v-if="tabPaneData.customer && tabPaneData.customer.id=='34241933737070592'">戴斌林专用</el-dropdown-item>
                  <el-dropdown-item command="发货单产品清单">产品清单(vip)</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-dropdown
                v-if="tabPaneData.status && (tabPaneData.status.code == 'WAIT_SHIPMENT' || tabPaneData.status.code == 'CANCEL_SHIPMENT')"
                @command="handleCommand"
                trigger="click"
              >
                <el-button v-if="tabPaneData.status && (tabPaneData.status.code == 'WAIT_SHIPMENT' || tabPaneData.status.code == 'CANCEL_SHIPMENT')"
                  class="downIcon"
                  type="primary"
                  icon="el-icon-d-arrow-right"
                  style="margin-right: 10px"
                  size="small"
                >
                  移除产品
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="清空">
                      清空
                  </el-dropdown-item>
                  <el-dropdown-item command="移除箱号SN" divided>
                    移除箱号SN
                  </el-dropdown-item>
                  <el-dropdown-item command="移除产品SN">
                    移除产品SN
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-dropdown
                v-if="tabPaneData.status && tabPaneData.status.code == 'WAIT_SHIPMENT'"
                @command="handleCommand"
                trigger="click"
              >
                <el-button v-if="tabPaneData.status && tabPaneData.status.code == 'WAIT_SHIPMENT'"
                  class="downIcon"
                  type="primary"
                  icon="el-icon-d-arrow-right"
                  style="margin-right: 10px"
                  size="small"
                >
                  添加产品
                  <!-- <i class="el-icon-d-arrow-right"></i> -->
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="包装工单">按包装工单</el-dropdown-item>
                  <el-dropdown-item command="组装工单">按组装工单</el-dropdown-item>
                  <el-dropdown-item command="连续箱号" divided>连续箱号Index</el-dropdown-item>
                  <el-dropdown-item command="零散箱号">零散箱号Index</el-dropdown-item>
                  <el-dropdown-item command="扫描箱号SN">零散箱号SN</el-dropdown-item>
                  <el-dropdown-item command="零散栈板" divided>零散栈板Index</el-dropdown-item>
                  <el-dropdown-item command="零散栈板SN">零散栈板SN</el-dropdown-item>
                  <el-dropdown-item command="零散SN" divided>已包装的零散SN</el-dropdown-item>
                  <el-dropdown-item command="零散未包装SN">未包装的零散SN</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-tooltip v-if="isMoreSearch"
                class="item"
                content="清除查询条件"
                placement="bottom"
                :open-delay="300"
              >
                <el-button
                  icon="iconfont icon-qingkong"
                  size="small"
                  class="cleanBox"
                  @click="onClear"
                ></el-button>
              </el-tooltip>
              <el-dropdown v-if="isMoreSearch"
                split-button
                type="primary"
                size="small"
                class="searchBox"
                @click="onSearch(false)"
                trigger="click"
              >
                查询
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="onSearch(true)"
                    >模糊查询</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <el-tooltip
              class="item"
              content="查询条件"
              placement="bottom"
              :open-delay="300"
            >
              <el-button
                class="btn_more"
                :class="{ activeUserMore: isMoreSearch }"
                size="small"
                icon="el-icon-d-arrow-right"
                @click="moreSearchBtn"
              ></el-button>
            </el-tooltip>
          </div>
        </el-tab-pane>
      </el-tabs>
      <el-form v-if="isMoreSearch && tabPaneValue == 'first'" :inline="true" :model="searchConditionForm" class="demo-form-inline">
        <div class="searchConditionBox">
          <el-form-item label="发货单号" size="small">
            <el-input v-model="searchConditionForm.orderNumber" placeholder="发货单号" clearable @keyup.enter.native="getShipmentOrderSearch()"></el-input>
          </el-form-item>
          <el-form-item label="销售订单" size="small">
            <el-input v-model="searchConditionForm.customerOrderNumber" placeholder="销售订单" clearable @keyup.enter.native="getShipmentOrderSearch()"></el-input>
          </el-form-item>
          <el-form-item label="客户" size="small">
            <el-select v-model="searchConditionForm.customerId" placeholder="选择客户名称" filterable clearable>
              <el-option v-for="(item, index) in pullDownData.customerList"
                :key="index" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="目的地" size="small">
            <el-input
              v-model="searchConditionForm.destination"
              placeholder="输入订单目的地"
              clearable
              @keyup.enter.native="getShipmentOrderSearch()"
            ></el-input>
          </el-form-item>
          <el-form-item label="承运人" size="small">
            <el-input
              v-model="searchConditionForm.express"
              placeholder="输入订单承运人"
              clearable
              @keyup.enter.native="getShipmentOrderSearch()"
            ></el-input>
          </el-form-item>
          <el-form-item label="车牌号" size="small">
            <el-input
              v-model="searchConditionForm.expressNumber"
              placeholder="输入订单号或车牌号"
              clearable
              @keyup.enter.native="getShipmentOrderSearch()"
            ></el-input>
          </el-form-item>
          <el-form-item label="发货日期" size="small">
            <el-date-picker
              v-model="searchConditionForm.exWarehouseDate"
              type="date"
              placeholder="发货日期"
              value-format="yyyy-MM-dd"
              :picker-options="$store.state.pickerOptions"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="工单状态" size="small">
            <el-select
              v-model="searchConditionForm.status"
              placeholder="选择工单状态"
              filterable
              multiple
              clearable
            >
              <el-option
                v-for="(item, index) in pullDownData.shipmentStatusList"
                :key="index"
                :label="item.title"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所有者" size="small">
            <el-select
              v-model="searchConditionForm.userId"
              placeholder="选择工单所有者"
              filterable
              clearable
              class="hiddenSelectDropdown"
              :popper-append-to-body="false"
              @visible-change="
                selectVisible($event, 'user', '员工选择', 'searchConditionForm')
              "
            >
              <el-option
                v-for="(item, index) in pullDownData.userList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
      </el-form>
      <el-form
        :inline="true"
        :model="devicesSearchForm"
        class="demo-form-inline"
        v-else-if="
          isMoreSearch && tabPaneValue != 'first' && cutDetail == 'devices'
        "
      >
        <div class="searchConditionBox">
          <el-form-item label="SN" size="small">
            <el-input
              v-model="devicesSearchForm.sn"
              placeholder="SN"
              clearable
              @keyup.enter.native="$refs.devicesPage.getShipmentOrderDevices()"
            ></el-input>
          </el-form-item>         
          <el-form-item v-if="tabPaneData.dpkStatus" label="CBR状态" size="small">
            <el-select v-model="devicesSearchForm.dpkStatus" placeholder="选择CBR状态" filterable clearable>
              <el-option key="WAITING_UPLOAD" label="待提交" value="WAITING_UPLOAD"></el-option>
              <el-option key="SUBMITTED" label="已提交" value="SUBMITTED"></el-option>
              <el-option key="WAITING_COMPLETED" label="待确定" value="WAITING_COMPLETED"></el-option>
              <el-option key="COMPLETED" label="已确认" value="COMPLETED"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-else label="UUID" size="small">
            <el-input
              v-model="devicesSearchForm.uuid"
              placeholder="UUID"
              clearable
              @keyup.enter.native="$refs.devicesPage.getShipmentOrderDevices()"
            ></el-input>
          </el-form-item>
          <el-form-item label="MAC" size="small">
            <el-input
              v-model="devicesSearchForm.mac"
              placeholder="网卡MAC、蓝牙MAC"
              clearable
              @keyup.enter.native="$refs.devicesPage.getShipmentOrderDevices()"
            ></el-input>
          </el-form-item>
          <el-form-item label="包装工单" size="small">
            <el-select
              v-model="devicesSearchForm.cartonOrderId"
              placeholder="选择包装工单"
              filterable
              clearable
            >
              <el-option
                v-for="(item, index) in pullDownData.cartonOrderList2"
                :key="index"
                :label="item.orderNumber"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="组装工单" size="small">
            <el-select
              v-model="devicesSearchForm.productionOrderId"
              placeholder="选择组装工单"
              filterable
              clearable
            >
              <el-option
                v-for="(item, index) in pullDownData.productionOrderList2"
                :key="index"
                :label="item.orderNumber"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
      </el-form>
      <input ref="uploadSubmitFidInput" type="file" @change="submitDpkBtn()" style="display: none"/>
      <input ref="uploadCompletFidInput" type="file" @change="completDpkBtn()" style="display: none"/>
    </div>
    <div class="contentBox">
      <div class="rightContent" v-if="tabPaneValue == 'first'">
        <el-table
          stripe
          :data="tableData"
          border
          style="width: 100%"
          height="100%"
          size="mini"
          @sort-change="sortChange"
        >
          <el-table-column
            type="index"
            :width="pagination.endIndex >= 1000 ? 80 : 50"
            align="center"
            :index="pagination.beginIndex"
          ></el-table-column>
          <el-table-column
            prop="orderNumber"
            label="发货单号"
            min-width="120"
            align="center"
            show-overflow-tooltip
            sortable="custom"
          >
            <template slot-scope="scope">
              <span class="allowSkip" @click="clickAllowSkip(scope.row)">{{
                scope.row.orderNumber
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="customerId"
            label="客户"
            min-width="120"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.customer">{{
                scope.row.customer.name
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="destination" label="目的地" align="center">
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                :content="scope.row.destination"
                placement="top"
                :open-delay="300"
              >
                <div class="textOverflow" v-if="scope.row.destination">
                  {{ scope.row.destination }}
                </div>
              </el-tooltip>
              <span v-if="!scope.row.destination">-</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="express"
            label="承运人"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.express">{{ scope.row.express }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="quantity"
            sortable="custom"
            label="数量"
            align="center"
            show-overflow-tooltip
          ></el-table-column>
          <!-- <el-table-column
            prop="uploadReport"
            label="上传报表"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.uploadReport">
                <span v-if="scope.row.uploadStatus">{{
                  scope.row.uploadStatus.title
                }}</span>
                <span v-else>待上传</span>
              </span>
              <span v-else>否</span>
            </template>
          </el-table-column> -->
          <el-table-column prop="exWarehouseDate" label="发货时间" align="center"
            sortable="custom" show-overflow-tooltip min-width="95px">
            <template slot-scope="scope">
              <span v-if="scope.row.exWarehouseDateTime">
                {{ scope.row.exWarehouseDateTime }}
              </span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="createUser" label="所有者" align="center" show-overflow-tooltip width="95px">
            <template slot-scope="scope">
              <span v-if="scope.row.createUser">
                {{ scope.row.createUser.name }} ({{ scope.row.createUser.employeeNum }})
              </span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="status"
            label="工单状态" width="105px"
            align="center"
            sortable="custom"
          >
              <template slot-scope="scope">
                <el-tooltip v-if="scope.row.status.code != 'CANCEL_SHIPMENT' && scope.row.timeOut && scope.row.timeOut>0"
                  class="item"
                  effect="dark"
                  :content="'已逾期【'+scope.row.timeOut +'天】，请及时发货！'"
                  placement="top"
                  :open-delay="300"
                >
                  <i class="iconfont icon-yiguoqi"></i>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" placement="top" :open-delay="300"
                  :content="scope.row.exWarehouseTime ? '发货时间：'+scope.row.exWarehouseTime : '建单时间：'+scope.row.createDate">
                  <span class="textOverflow" v-if="scope.row.status">
                    {{ scope.row.status.title }}
                  </span>
                </el-tooltip>
                <span v-if="!scope.row.status">-</span>
              </template>
            <!-- <template slot-scope="scope">
              <span v-if="scope.row.status">
                {{ scope.row.status.title }}</span>
              <span v-else>-</span>
            </template> -->
          </el-table-column>
          <el-table-column prop="uploadStatus" label="上传状态" align="center" show-overflow-tooltip width="95px">
            <template slot-scope="scope">
              <span v-if="scope.row.uploadStatus && scope.row.uploadStatus.code!='NONE'"
                :class="scope.row.uploadStatus.code=='FAIL' ? 'fail' : ''">
                {{ scope.row.uploadStatus.title }}
              </span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column class-name="operation" width="95px" label="操作" align="center">
            <template slot-scope="scope">
              <el-tooltip
                v-if="scope.row.status && scope.row.status.code=='WAIT_SHIPMENT'"
                class="item"
                effect="dark"
                content="交接"
                placement="top"
                :open-delay="300"
              >
                <i
                  @click="handover($event, scope.row)"
                  class="iconfont icon-jiaojie"
                ></i>
              </el-tooltip>
              <el-tooltip
                v-if="scope.row.status && scope.row.status.code=='WAIT_SHIPMENT'"
                class="item"
                effect="dark"
                content="删除"
                placement="top"
                :open-delay="300"
              >
                  <i
                    @click="deleteOrder($event, scope.row)"
                    class="el-icon-delete"
                  ></i>
              </el-tooltip>
              <span v-else>-</span>
            </template>
          </el-table-column>
        </el-table>
        <pagination
          :pagination="pagination"
          @currentChange="currentChange"
          @sizeChange="sizeChange"
          @refreshBtn="getShipmentOrderSearch"
        ></pagination>
      </div>
      <div class="rightContent" v-else>
        <detailPage
          ref="detailPage"
          v-if="cutDetail == 'detail'"
          :tabPaneValue="tabPaneValue"
        ></detailPage>
        <devicesPage
          ref="devicesPage"
          v-else-if="cutDetail == 'devices'"
          :tabPaneValue="tabPaneValue"
          :tabPaneData="tabPaneData"
          :devicesSearchForm="devicesSearchForm"
        ></devicesPage>
      </div>
    </div>
    <myDialog
      ref="myDialog"
      :title="dialogTitle"
      @submitData="submitData"
      @dialogClose="dialogClose"
      width="450px"
    >
      <template slot="content">
        <div v-if="dialogTitle == '交接发货工单'" key="pe">
          <el-form
            ref="dialogForm"
            :model="HandoverForm"
            :rules="dialogRules"
            :label-width="labelWidth"
          >
            <el-form-item
              label="新所有者："
              size="small"
              prop="userId"
            >
            <el-select
              v-model="HandoverForm.userId"
              placeholder="选择新所有者"
              filterable
              clearable
              class="hiddenSelectDropdown"
              :popper-append-to-body="false"
              @visible-change="
                selectVisible($event, 'user', '员工选择', 'HandoverForm')
              "
            >
              <el-option
                v-for="(item, index) in pullDownData.userList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div v-else>
          <div v-show="dialogTitle == '发货'" class="tips">
            温馨提示：发货后不能再添加产品！
          </div>
          <el-form
            ref="dialogForm"
            :model="dialogForm"
            :rules="dialogRules"
            :label-width="labelWidth"
          >
            <div v-if="dialogTitle == '新建发货工单'">
              <el-form-item label="客户" size="small" prop="customerId">
                <el-select
                  v-model="dialogForm.customerId"
                  placeholder="选择客户名称"
                  filterable
                  clearable
                  @change="customerChange"
                >
                  <el-option
                    v-for="(item, index) in pullDownData.customerList"
                    :key="index"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="包装工单" size="small" prop="cartonOrderIds">
                <el-select
                  v-model="dialogForm.cartonOrderIds"
                  placeholder="选择包装工单号"
                  filterable
                  clearable
                  class="hiddenSelectDropdown"
                  :popper-append-to-body="false"
                  @visible-change="
                    selectVisible($event, 'cartonOrder', '包装工单')
                  "
                  :disabled="!dialogForm.customerId"
                  multiple
                >
                  <el-option
                    v-for="item in pullDownData.cartonOrderList"
                    :key="item.id"
                    :label="item.orderNumber"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="发货单号" size="small" prop="orderNumber">
                <el-input
                  v-model="dialogForm.orderNumber"
                  placeholder="发货工单号"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="发货数量" size="small" prop="quantity">
                <el-input-number
                  v-model="dialogForm.quantity"
                  :min="0"
                  :precision="0"
                  size="small"
                  placeholder="发货数量"
                  :controls="false"
                ></el-input-number>
              </el-form-item>
              <el-form-item label="目的地" size="small">
                <el-input
                  v-model="dialogForm.destination"
                  placeholder="输入目的地"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="客户入库单号" size="small" prop="srmOrderNum">
                <el-input
                  v-model="dialogForm.srmOrderNum"
                  placeholder="输入客户入库单号"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="客户物料编码" size="small" prop="partNum">
                <el-input
                  v-model="dialogForm.partNum"
                  placeholder="输入客户物料编码"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="备注" size="small" prop="notes">
                <el-input
                  v-model="dialogForm.notes"
                  type="textarea"
                  :autosize="{ minRows: 2, maxRows: 4 }"
                  placeholder="备注信息"
                ></el-input>
              </el-form-item>
            </div>
            <div v-else-if="dialogTitle == '发货'">
              <el-form-item label="承运人：" size="small" prop="express">
                <el-input
                  v-model="dialogForm.express"
                  placeholder="司机、快递公司名称等，如：顺丰、UPS、马司机"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="运单号：" size="small" prop="expressNumber">
                <el-input
                  v-model="dialogForm.expressNumber"
                  placeholder="车牌、快递单号等，如：粤888888、JDVB191112002"
                  clearable
                ></el-input>
              </el-form-item>
            </div>
          </el-form>
        </div>
      </template>
    </myDialog>
    <myDialog
      ref="addDeviceDialog"
      :title="`添加产品-根据${addDeviceTitle}`"
      @submitData="addDeviceSubmit"
      @dialogClose="addDeviceClose"
      width="450px"
    >
      <template slot="content">
        <el-form
          ref="addDeviceForm"
          :model="addDeviceForm"
          :rules="addDeviceRules"
          :label-width="labelWidth"
        >
          <div v-if="addDeviceTitle == '包装工单'">
            <el-form-item label="包装工单：" size="small" prop="cartonOrderId">
              <el-select
                v-model="addDeviceForm.cartonOrderId"
                placeholder="选择包装工单号"
                filterable
                clearable
              >
                <el-option
                  v-for="item in pullDownData.cartonOrderList2"
                  :key="item.id"
                  :label="item.orderNumber"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div v-else-if="addDeviceTitle == '连续箱号'">
            <el-form-item label="包装工单：" size="small" prop="cartonOrderId">
              <el-select
                v-model="addDeviceForm.cartonOrderId"
                placeholder="选择包装工单号"
                filterable
                clearable
              >
                <el-option
                  v-for="item in pullDownData.cartonOrderList2"
                  :key="item.id"
                  :label="item.orderNumber"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="起始箱号：" size="small" prop="beginIndex">
              <el-input-number
                v-model="addDeviceForm.beginIndex"
                :min="1"
                :precision="0"
                size="small"
                placeholder="输入起始箱号(数字索引)"
                @change="beginIndexChange"
                :controls="false"
              ></el-input-number>
            </el-form-item>
            <el-form-item label="结束箱号：" size="small" prop="endIndex">
              <el-input-number
                v-model="addDeviceForm.endIndex"
                :min="1"
                :precision="0"
                size="small"
                placeholder="输入结束箱号(数字索引)"
                @change="endIndexChange"
                :controls="false"
              ></el-input-number>
            </el-form-item>
          </div>
          <div v-else-if="addDeviceTitle == '移除产品SN'">
            <el-form-item label="包装工单：" size="small" prop="cartonOrderId">
              <el-select
                v-model="addDeviceForm.cartonOrderId"
                placeholder="选择包装工单号"
                filterable
                clearable
              >
                <el-option
                  v-for="item in pullDownData.cartonOrderList2"
                  :key="item.id"
                  :label="item.orderNumber"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="产品SN：" size="small" prop="sn">
              <el-input
                :value="addDeviceForm.sn"
                type="textarea"
                :autosize="{ minRows: 5, maxRows: 20 }"
                placeholder="格式：每行一个产品SN"
                resize="none"
                @input="addDeviceSNInput"
              ></el-input>
            </el-form-item>
          </div>
          <div v-else-if="addDeviceTitle == '移除箱号SN'">
            <el-form-item label="包装工单：" size="small" prop="cartonOrderId">
              <el-select
                v-model="addDeviceForm.cartonOrderId"
                placeholder="选择包装工单号"
                filterable
                clearable
              >
                <el-option
                  v-for="item in pullDownData.cartonOrderList2"
                  :key="item.id"
                  :label="item.orderNumber"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="箱号SN：" size="small" prop="sn">
              <el-input
                :value="addDeviceForm.sn"
                type="textarea"
                :autosize="{ minRows: 5, maxRows: 20 }"
                placeholder="格式：每行一个箱号SN"
                resize="none"
                @input="addDeviceSNInput"
              ></el-input>
            </el-form-item>
          </div>
          <div v-else-if="addDeviceTitle == '零散栈板SN'">
            <el-form-item label="包装工单：" size="small" prop="cartonOrderId">
              <el-select
                v-model="addDeviceForm.cartonOrderId"
                placeholder="选择包装工单号"
                filterable
                clearable
              >
                <el-option
                  v-for="item in pullDownData.cartonOrderList2"
                  :key="item.id"
                  :label="item.orderNumber"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="栈板SN：" size="small" prop="palletSns">
              <el-input
                :value="addDeviceForm.palletSns"
                type="textarea"
                :autosize="{ minRows: 5, maxRows: 20 }"
                placeholder="格式：每行一个栈板SN"
                resize="none"
                @input="palletSnsInput"
              ></el-input>
            </el-form-item>
          </div>
          <div v-else-if="addDeviceTitle == '零散栈板'">
            <el-form-item label="包装工单：" size="small" prop="cartonOrderId">
              <el-select
                v-model="addDeviceForm.cartonOrderId"
                placeholder="选择包装工单号"
                filterable
                clearable
              >
                <el-option
                  v-for="item in pullDownData.cartonOrderList2"
                  :key="item.id"
                  :label="item.orderNumber"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="栈板Index：" size="small" prop="palletIndexes">
              <el-input
                :value="addDeviceForm.palletIndexes"
                type="textarea"
                :autosize="{ minRows: 5, maxRows: 20 }"
                placeholder="格式：每行一个栈板Index(数字)"
                resize="none"
                @input="palletIndexesInput"
              ></el-input>
            </el-form-item>
          </div>
          <div v-else-if="addDeviceTitle == '零散箱号'">
            <el-form-item label="包装工单：" size="small" prop="cartonOrderId">
              <el-select
                v-model="addDeviceForm.cartonOrderId"
                placeholder="选择包装工单号"
                filterable
                clearable
              >
                <el-option
                  v-for="item in pullDownData.cartonOrderList2"
                  :key="item.id"
                  :label="item.orderNumber"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="零散箱号：" size="small" prop="indexes">
              <el-input
                :value="addDeviceForm.indexes"
                type="textarea"
                :autosize="{ minRows: 5, maxRows: 20 }"
                placeholder="格式：每行一个箱号(数字索引)"
                resize="none"
                @input="indexesInput"
              ></el-input>
            </el-form-item>
          </div>
          <div v-else-if="addDeviceTitle == '扫描箱号SN'">
            <el-form-item label="包装工单：" size="small" prop="cartonOrderId">
              <el-select
                v-model="addDeviceForm.cartonOrderId"
                placeholder="选择包装工单号"
                filterable
                clearable
              >
                <el-option
                  v-for="item in pullDownData.cartonOrderList2"
                  :key="item.id"
                  :label="item.orderNumber"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="栈板SN：" size="small" prop="palletSn">
              <el-input
                v-model="addDeviceForm.palletSn"
                size="small"
                placeholder="栈板SN"
              ></el-input>
            </el-form-item>
            <el-form-item label="箱号SN：" size="small" prop="sn">
              <el-input
                :value="addDeviceForm.sn"
                type="textarea"
                :autosize="{ minRows: 5, maxRows: 20 }"
                placeholder="格式：每行一个箱号SN"
                resize="none"
                @input="addDeviceSNInput"
              ></el-input>
            </el-form-item>
          </div>
          <div v-else-if="addDeviceTitle == '返工SN'">
            <el-form-item label="SN列表：" size="small" prop="sn">
            <el-input
              v-model="addDeviceForm.sn"
              type="textarea"
              :autosize="{ minRows: 5, maxRows: 20 }"
              placeholder="格式：每行一个SN"
              resize="none"
              @input="addDeviceSNInput"
            ></el-input>
          </el-form-item>
          </div>
          <div v-else-if="addDeviceTitle == '零散SN'">
            <el-form-item label="包装工单：" size="small" prop="cartonOrderId">
              <el-select
                v-model="addDeviceForm.cartonOrderId"
                placeholder="选择包装工单号"
                filterable
                clearable
              >
                <el-option
                  v-for="item in pullDownData.cartonOrderList2"
                  :key="item.id"
                  :label="item.orderNumber"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="SN列表：" size="small" prop="sn">
              <el-input
                v-model="addDeviceForm.sn"
                type="textarea"
                :autosize="{ minRows: 5, maxRows: 20 }"
                placeholder="格式：每行一个SN"
                resize="none"
                @input="addDeviceSNInput"
              ></el-input>
            </el-form-item>
          </div>
          <div v-else-if="addDeviceTitle == '零散未包装SN'">
            <el-form-item label="组装工单：" size="small" prop="productionOrderId">
              <el-select
                v-model="addDeviceForm.productionOrderId"
                placeholder="选择组装工单号"
                filterable
                clearable
              >
                <el-option
                  v-for="item in pullDownData.productionOrderList2"
                  :key="item.id"
                  :label="item.orderNumber"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="SN列表：" size="small" prop="sn">
              <el-input
                v-model="addDeviceForm.sn"
                type="textarea"
                :autosize="{ minRows: 5, maxRows: 20 }"
                placeholder="格式：每行一个SN"
                resize="none"
                @input="addDeviceSNInput"
              ></el-input>
            </el-form-item>
          </div>
          <div v-else-if="addDeviceTitle == '组装工单'">
            <el-form-item
              label="组装工单："
              size="small"
              prop="productionOrderId"
            >
              <el-select
                v-model="addDeviceForm.productionOrderId"
                placeholder="选择组装工单号"
                filterable
                clearable
              >
                <el-option
                  v-for="item in pullDownData.productionOrderList2"
                  :key="item.id"
                  :label="item.orderNumber"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-form>
      </template>
    </myDialog>
    <orderTableSelect
      ref="orderTableSelect"
      @orderTableSubmit="orderTableSubmit"
    ></orderTableSelect>
  </div>
</template>

<script>
import pagination from "@/components/pagination.vue";
import myDialog from "@/components/myDialog.vue";
import detailPage from "./components/detailPage.vue";
import devicesPage from "./components/devicesPage.vue";
import orderTableSelect from "@/components/orderTableSelect.vue";
import {
  apiShipmentOrderSearch,
  apiShipmentOrderAdd,
  apiCustomerList,
  apiShipmentStatusList,
  apiShipExportCarton,
  apiShipExportPallet,
  apiShipmentOrderExport,
  apiShipmentOrderDevicesExport,
  apiAddDeviceByCartonOrder,
  apiAddDeviceByIndex,
  apiAddDeviceByIndexes,
  apiAddDeviceByPalletIndexes,
  apiAddDeviceByPalletSns,
  apiAddDeviceBySN,
  apiAddWithoutPackagingSn,
  apiAddDeviceByCtn,
  apiAddDeviceByProductionOrder,
  apiShipmentOrderExWarehouse,
  apiShipmentOrderRemove,
  apiShipClearDevice,
  apiHandoverOrder, apiShipmentOrderRollbackExWarehouse,
  apiDpkCbrSubmitted, apiDpkCbrCompleted,
  apiReworkByShipmentOrder, apiRemoveDeviceBySn, apiRemoveDeviceByCtn,
} from "@/api/shipmentOrder.js";
import { apiDownloadFile, apiUploadFile } from "@/api/filesUpload.js";
export default {
  lastModuleConfig: { modulePath: "/homePage/shipmentOrder" },
  components: {
    pagination,
    myDialog,
    detailPage,
    devicesPage,
    orderTableSelect,
  },
  data() {
    return {
      tabPaneList: [],
      tabPaneData: {
        status: {},
        dpkStatus: {}
      },
      tabPaneValue: "first",
      isMoreSearch: false,
      searchConditionForm: {},
      devicesSearchForm: {},
      HandoverForm: {},
      pullDownData: {
        customerList: [],
        uploadStatusList: [],
        shipmentStatusList: [],
        productionOrderList2: [],
        cartonOrderList: [],
        cartonOrderList2: [],
        userList: [], // 员工列表
      },
      cutDetail: "detail",
      tableData: [
        
      ],
      desc: undefined,
      orderBy: [],
      pagination: {
        currentPage: 1,
        pageSize: 40,
        total: 102,
        beginIndex: 1,
        endIndex: 10,
      },
      dialogTitle: "",
      dialogForm: {
        cartonOrderIds: [],
      },
      dialogRules: {
        userId: [
          { required: true, message: "工单的新所有者不能为空！", trigger: "change" },
        ],
        customerId: [
          { required: true, message: "客户名称不能为空！", trigger: "change" },
        ],
        cartonOrderIds: [
          { required: true, message: "包装工单不能为空！", trigger: "change" },
        ],
        orderNumber: [
          { required: true, message: "发货单号不能为空！", trigger: "blur" },
          {
            min: 4,
            max: 64,
            message: "长度在 4 到 64 个字符",
            trigger: "change",
          },
        ],
        quantity: [
          { required: true, message: "发货数量不能为空！", trigger: "blur" },
        ],
        express: [
          {
            required: true,
            message: "司机、快递公司名称不能为空！",
            trigger: "change",
          },
        ],
        expressNumber: [
          {
            required: true,
            message: "车牌、快递单号不能为空！",
            trigger: "change",
          },
        ],
      },
      addDeviceTitle: "",
      addDeviceForm: {},
      addDeviceRules: {
        cartonOrderId: [
          { required: true, message: "包装工单不能为空！", trigger: "change" },
        ],
        beginIndex: [
          { required: true, message: "起始箱号不能为空！", trigger: "blur" },
        ],
        endIndex: [
          { required: true, message: "结束箱号不能为空！", trigger: "blur" },
        ],
        indexes: [
          { required: true, message: "零散箱号不能为空！", trigger: "blur" },
        ],
        palletIndexes: [
          { required: true, message: "零散栈板Index不能为空！", trigger: "blur" },
        ],
        palletSns: [
          { required: true, message: "零散栈板SN不能为空！", trigger: "blur" },
        ],
        productionOrderId: [
          { required: true, message: "组装工单不能为空！", trigger: "change" },
        ],
        sn: [{ required: true, message: "SN不能为空！", trigger: "blur" }],
      },
      labelWidth: this.$store.state.labelWidth,
    };
  },
  watch: {
    tabPaneValue: function (newVal) {
      this.$moreSearchStyle();
      if (newVal == "first") {
        this.getShipmentOrderSearch();
      } else {
        this.$nextTick(() => {
          this.$set(this.devicesSearchForm, "cartonOrderId", undefined);
          this.$set(this.devicesSearchForm, "productionOrderId", undefined);
          this.tabPaneList.forEach((item) => {
            if (item.id == newVal) {
              this.tabPaneData = item;
            }
          });
          if (this.cutDetail == "detail") {
            this.$refs.detailPage.getShipmentOrderDetail();
          } else if (this.cutDetail == "devices") {
            this.$refs.devicesPage.pagination.currentPage = 1;
            this.$refs.devicesPage.getShipmentOrderDevices("", () => {
              this.$refs.devicesPage.getProductionOrders();
              this.$refs.devicesPage.getCartonOrderList();
            });
          }
        });
      }
    },
  },
  methods: {
    rework() {
      this.addDeviceTitle = '返工SN';
      this.$refs.addDeviceDialog.dialogVisible = true;
    },
    // 删除工单
    deleteOrder(e, row) {
      e.target.blur();
      this.$allOperation({ name: row.orderNumber }, "删除", "发货工单").then(
        async () => {
          const res = await apiShipmentOrderRemove({
            id: row.id
          });
          if (res.code == 0) {
            this.getShipmentOrderSearch();
            this.$message({
              message: "删除成功",
              type: "success",
            });
          }
        }
      );
    },
    // 交接工单
    handover(e, row) {
      this.dialogTitle = "交接发货工单";
      this.$refs.myDialog.dialogVisible = true;
      this.HandoverForm = {
        id: row.id
      };
    },
    // 切换一级面板
    tabPaneClick(tab) {
      this.tabPaneValue = tab.name;
    },
    // 关闭一级面板
    closeTabPane(index) {
      if (this.tabPaneList[index].id == this.tabPaneValue) {
        if (index > 0) {
          this.tabPaneValue = this.tabPaneList[index - 1].id;
        } else {
          this.tabPaneValue = "first";
        }
      }
      this.tabPaneList.splice(index, 1);
    },
    // 切换详情-二级面板
    cutDetailChange(value) {
      this.cutDetail = value;
      this.$moreSearchStyle();
      this.$nextTick(() => {
        if (value == "detail") {
          this.$refs.detailPage.getShipmentOrderDetail();
        } else if (value == "devices") {
          this.$refs.devicesPage.getShipmentOrderDevices("", () => {
            this.$refs.devicesPage.getCartonOrderList();
            this.$refs.devicesPage.getProductionOrders();
          });
        }
      });
    },
    // 表格数据
    async getShipmentOrderSearch(remove, callback) {
      if (!(remove == "noRemove")) {
        this.tableData = [];
      }
      const res = await apiShipmentOrderSearch({
        ...this.searchConditionForm,
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        desc: this.desc,
        orderBy: this.orderBy,
      });
      // console.log(res);
      if (res.code == 0) {
        this.tableData = res.data;
        this.pagination.total = res.total;
        this.pagination.beginIndex = res.beginIndex;
        this.pagination.endIndex = res.endIndex;
        if (callback) callback();
      }
    },
    // 更多查询
    moreSearchBtn() {
      this.isMoreSearch = !this.isMoreSearch;
      this.$moreSearchStyle();
    },
    // 新建发货工单
    addNewBtn() {
      this.dialogTitle = "新建发货工单";
      this.$refs.myDialog.dialogVisible = true;
    },
    // 确认新建
    submitData(title, force) {
      this.$refs.dialogForm.validate(async (valid) => {
        if (valid) {
          let res = {};
          if (title == "新建发货工单") {
            res = await apiShipmentOrderAdd({
              ...this.dialogForm,
            });
            if (res.code == 0) {
              this.$refs.myDialog.dialogVisible = false;
              this.$message({
                message: "新建成功",
                type: "success",
              });
              this.getShipmentOrderSearch();
            }
          } else if (title == "发货") {
            res = await apiShipmentOrderExWarehouse({
              id: this.tabPaneValue,
              express: this.dialogForm.express,
              expressNumber: this.dialogForm.expressNumber,
              force
            });
            if (res.code == 0) {
              this.$refs.myDialog.dialogVisible = false;
              if (this.cutDetail == "devices") {
                this.$refs.devicesPage.getShipmentOrderDevices();
              }
              this.tabPaneData.status = {
                code: "EX_WAREHOUSE",
                title: "已发货",
              };
              this.$message({
                message: "发货成功",
                type: "success",
              });
            } else if (res.code == 1024) {
              this.$confirm(res.msg, "强制执行", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }).then(() => {
                this.submitData(title, true);
              });
            }
          } else if (title == "交接发货工单") {
            const res = await apiHandoverOrder({
              ...this.HandoverForm
            });
            if (res.code == 0) {
              this.$refs.myDialog.dialogVisible = false;
              this.getShipmentOrderSearch();
              this.$message({
                message: "工单所有者交接成功",
                type: "success",
              });
            }
          }
        } else {
          return false;
        }
      });
    },
    // 关闭对话框
    dialogClose() {
      this.$refs.dialogForm.resetFields();
      this.dialogForm = {
        cartonOrderIds: [],
      };
    },
    onlyMyChange() {
        this.getShipmentOrderSearch();
    },
    // 清除查询
    onClear() {
      if (this.tabPaneValue == "first") {
        this.searchConditionForm = {};
        this.pagination.currentPage = 1;
        this.getShipmentOrderSearch();
      } else {
        if (this.cutDetail == "devices") {
          this.devicesSearchForm = {};
          this.$refs.devicesPage.pagination.currentPage = 1;
          // props传参数据有延迟，需要nextTick延迟调用数据
          this.$nextTick(() => {
            this.$refs.devicesPage.getShipmentOrderDevices();
          });
        }
      }
    },
    // 确认查询
    onSearch(value) {
      if (this.tabPaneValue == "first") {
        this.pagination.currentPage = 1;
        this.getShipmentOrderSearch();
      } else {
        if (this.cutDetail == "devices") {
          this.devicesSearchForm.like = value;
          this.$refs.devicesPage.pagination.currentPage = 1;
          this.$refs.devicesPage.getShipmentOrderDevices();
        }
      }
    },    
    downloadFile(fid, fileName, secret) {
      let a = document.createElement("a");
      a.download = fileName;
      a.href = apiDownloadFile(fid, secret);
      a.style.display = "none";
      a.target = "_blank";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    devicesDownloadBtn(command) {
      let res = {};
      if (command == "发货单报表2") {
        const h = this.$createElement;
        this.$msgbox({
          title: `戴斌林专用`,
          message: h("div", null, [
            h(
              "span",
              null,
              `请问:【`
            ),
            h("i", { style: "color: var(--themeColor)" }, "威尼斯"),
            h("span", null, `】是什么梗？`),
          ]),
          showCancelButton: true,
          confirmButtonText: `确认`,
          cancelButtonText: "取消",
          closeOnClickModal: false,
          showInput: true,
          beforeClose: (action, instance, done) => {
            if (action === "confirm") {
              if (instance.inputValue == "我同学" || instance.inputValue == "初恋") {
                done();
              } else {
                this.$message({
                  type: "warning",
                  message: `输入错误，请重新输入或取消！`,
                });
              }
            } else {
              done();
            }
          },
        }).then(async () => {            
            res = await apiShipmentOrderExport({
              id: this.tabPaneValue,
              force: true
            });
            if (res.code == 0) {
              this.downloadFile(res.fid, res.fileName, res.secretKey);
            }
        });
      } else {
        this.$confirm(`确认导出${command}吗？`, "导出文件", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(async () => {
          if (command == "箱标") {
            res = await apiShipExportCarton({
              id: this.tabPaneValue,
            });
          } else if (command == "栈板标") {
            res = await apiShipExportPallet({
              id: this.tabPaneValue,
            });
          } else if (command == "发货单报表") {
            res = await apiShipmentOrderExport({
              id: this.tabPaneValue,
            });
          } else if (command == "发货单产品清单") {
            res = await apiShipmentOrderDevicesExport({
              id: this.tabPaneValue,
            });
          } else {
            alert("错误的："+command);
            return;
          }
          
          if (res.code == 0) {
              this.downloadFile(res.fid, res.fileName, res.secretKey);
          } else if (res.code == 1024) {
            this.$confirm(res.msg, "强制执行", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            }).then(async() => {
              res = await apiShipmentOrderExport({
                id: this.tabPaneValue,
                force: true
              });
              if (res.code == 0) {
                this.downloadFile(res.fid, res.fileName, res.secretKey);
              }
            });
          }
        });
      }
        
      this.$refs.devicesPage.getShipmentOrderDevices();
    },
    // 产品列表--发货
    exWarehouseBtn() {
      this.dialogTitle = "发货";
      this.$refs.myDialog.dialogVisible = true;
    },
    rollbackExWarehouseBtn(e, row) {
      e.target.blur();
      const h = this.$createElement;
      this.$msgbox({
        title: `警告：如果货物已从物流发出，请勿使用此功能！`,
        message: h("div", null, [
          h(
            "span",
            null,
            `请输入发货单号:【`
          ),
          h("i", { style: "color: var(--themeColor)" }, row.orderNumber),
          h("span", null, `】以取消发货！`),
        ]),
        showCancelButton: true,
        confirmButtonText: `确认`,
        cancelButtonText: "取消",
        closeOnClickModal: false,
        showInput: true,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            if (instance.inputValue == row.orderNumber) {
              done();
            } else {
              this.$message({
                type: "warning",
                message: `输入错误，请重新输入或取消！`,
              });
            }
          } else {
            done();
          }
        },
      }).then(async () => {
        const res = await apiShipmentOrderRollbackExWarehouse({
          id: row.id
        });
        if (res.code == 0) {
          this.$message({
            type: "success",
            message: res.msg
          });
          this.$refs.detailPage.getShipmentOrderDetail();
        }
      });
    },
    // 上传完成后提交Submitted_CBR.csv
    uploadSubmitDpkBtn() {
      this.$nextTick(() => {
        this.$refs.uploadSubmitFidInput.click();
      });
    },
    async submitDpkBtn() {
      let files = this.$refs.uploadSubmitFidInput.files;
      if (files.length) {
        let fd = new FormData();        
        fd.append("file", files[0]);
        let res = await apiUploadFile(fd);
        if (res.code == 0) {
          this.$refs.uploadSubmitFidInput.value = "";
          const resBind = await apiDpkCbrSubmitted({
            id: this.tabPaneValue,
            fid: res.fid,
          });
          if (resBind.code == 0) {
            this.tabPaneData.dpkStatus.code = 'SUBMITTED';
            this.tabPaneData.dpkStatus.title = '已提交';
            this.$message({
              type: "success",
              message: `Submitted_CBR.csv上传成功！`,
            });
          }
        }
      }
    },
    
    // 审核通过后提交Completed_CBR.csv
    async uploadCompletDpkBtn() {
      this.$nextTick(() => {
        this.$refs.uploadCompletFidInput.click();
      });
    },
    async completDpkBtn() {
      let files = this.$refs.uploadCompletFidInput.files;
      if (files.length) {
        let fd = new FormData();        
        fd.append("file", files[0]);
        let res = await apiUploadFile(fd);
        if (res.code == 0) {
          this.$refs.uploadCompletFidInput.value = "";
          const resBind = await apiDpkCbrCompleted({
            id: this.tabPaneValue,
            fid: res.fid,
          });
          if (resBind.code == 0) {
            this.tabPaneData.dpkStatus.code = 'COMPLETED';
            this.tabPaneData.dpkStatus.title = '已确认';
            this.$message({
              type: "success",
              message: `Completed_CBR.csv上传成功！`,
            });
          }
        }
      }
    },
    clearDevicesBtn() {
      const h = this.$createElement;
      this.$msgbox({
        title: `清空产品`,
        message: h("div", null, [
          h("span", null, `输入发货工单单号：【`),
          h("i", { style: "color: var(--themeColor)" }, this.tabPaneData.orderNumber),
          h("span", null, `】以确认清空工单内已添加的所有产品！`),
        ]),
        showCancelButton: true,
        confirmButtonText: `确定清空`,
        cancelButtonText: "取消",
        closeOnClickModal: false,
        showInput: true,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            if (instance.inputValue === this.tabPaneData.orderNumber) {
              done();
            } else {
              this.$message({
                type: "warning",
                message: `输入错误，请重新输入或取消！`,
              });
            }
          } else {
            done();
          }
        },
      }).then(async () => {
        const res = await apiShipClearDevice({
          id: this.tabPaneData.id,
        });
        if (res.code == 0) {
          this.$refs.devicesPage.getShipmentOrderDevices();
          this.$message({
            message: "清空成功",
            type: "success",
          });
        }
      });
    },
    // 产品列表--添加产品
    handleCommand(command) {
      if (command == "清空") {
        this.clearDevicesBtn();
      } else {
        this.addDeviceTitle = command;
        this.$refs.addDeviceDialog.dialogVisible = true;
      }
    },
    // 产品列表--确认添加
    addDeviceSubmit(title, force) {
      this.$refs.addDeviceForm.validate(async (valid) => {
        if (valid) {
          let command = this.addDeviceTitle;
          let res = {};
          if (command == "包装工单") {
            res = await apiAddDeviceByCartonOrder({
              id: this.tabPaneValue,
              cartonOrderId: this.addDeviceForm.cartonOrderId,
              force,
            });
          } else if (command == "连续箱号") {
            res = await apiAddDeviceByIndex({
              id: this.tabPaneValue,
              cartonOrderId: this.addDeviceForm.cartonOrderId,
              beginIndex: this.addDeviceForm.beginIndex,
              endIndex: this.addDeviceForm.endIndex,
              force,
            });
          } else if (command == "零散栈板SN") {
            res = await apiAddDeviceByPalletSns({
              id: this.tabPaneValue,
              cartonOrderId: this.addDeviceForm.cartonOrderId,
              palletSns: this.addDeviceForm.palletSns.split("\n").filter((item) => {
                if (item) {
                  return true;
                }
              }),
              force,
            });
          } else if (command == "零散栈板") {
            res = await apiAddDeviceByPalletIndexes({
              id: this.tabPaneValue,
              cartonOrderId: this.addDeviceForm.cartonOrderId,
              palletIndexes: this.addDeviceForm.palletIndexes.split("\n").filter((item) => {
                if (item > 0) {
                  return true;
                }
              }),
              force,
            });
          } else if (command == "零散箱号") {
            res = await apiAddDeviceByIndexes({
              id: this.tabPaneValue,
              cartonOrderId: this.addDeviceForm.cartonOrderId,
              indexes: this.addDeviceForm.indexes.split("\n").filter((item) => {
                if (item > 0) {
                  return true;
                }
              }),
              force,
            });
          } else if (command == "扫描箱号SN") {
            res = await apiAddDeviceByCtn({
              id: this.tabPaneValue,
              palletSn:this.addDeviceForm.palletSn,
              cartonOrderId: this.addDeviceForm.cartonOrderId,
              ctn: this.addDeviceForm.sn.split("\n").filter((item) => {
                if (item != 0) {
                  return true;
                }
              }),
              force,
            })
          } else if (command == "零散SN") {
            res = await apiAddDeviceBySN({
              id: this.tabPaneValue,
              cartonOrderId: this.addDeviceForm.cartonOrderId,
              sn: this.addDeviceForm.sn.split("\n").filter((item) => {
                if (item != 0) {
                  return true;
                }
              }),
              force,
            });
          }else if (command == "零散未包装SN") {
            res = await apiAddWithoutPackagingSn({
              id: this.tabPaneValue,
              productionOrderId: this.addDeviceForm.productionOrderId,
              sn: this.addDeviceForm.sn.split("\n").filter((item) => {
                if (item != 0) {
                  return true;
                }
              }),
              force,
            });
          } else if (command == "组装工单") {
            res = await apiAddDeviceByProductionOrder({
              id: this.tabPaneValue,
              productionOrderId: this.addDeviceForm.productionOrderId,
              force,
            });
          } else if (command == "返工SN") {
            res = await apiReworkByShipmentOrder({
              id: this.tabPaneValue,
              sn: this.addDeviceForm.sn.split("\n").filter((item) => {
                if (item != 0) {
                  return true;
                }
              }),              
              orderType: 2
            });
          } else if (command == "移除箱号SN") {
            res = await apiRemoveDeviceByCtn({
              id: this.tabPaneValue,
              cartonOrderId: this.addDeviceForm.cartonOrderId,
              sn: this.addDeviceForm.sn.split("\n").filter((item) => {
                if (item != 0) {
                  return true;
                }
              }),
              force,
            });
          } else if (command == "移除产品SN") {
            res = await apiRemoveDeviceBySn({
              id: this.tabPaneValue,
              cartonOrderId: this.addDeviceForm.cartonOrderId,
              sn: this.addDeviceForm.sn.split("\n").filter((item) => {
                if (item != 0) {
                  return true;
                }
              }),
              force,
            });
          } else {
            this.$message({
              message: "不支持的操作！",
              type: "error",
            });
          }
          if (res.code == 0) {
            this.$refs.addDeviceDialog.dialogVisible = false;
            this.$refs.devicesPage.pagination.currentPage = 1;
            this.$refs.devicesPage.getShipmentOrderDevices();
            this.$message({
              message: res.msg,
              type: "success",
            });
          } else if (res.code == 1024) {
            this.$confirm(res.msg, "强制执行", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            }).then(() => {
              this.addDeviceSubmit("", true);
            });
          }
        } else {
          return false;
        }
      });
    },
    // 产品列表--关闭添加
    addDeviceClose() {
      this.$refs.addDeviceForm.resetFields();
      this.addDeviceForm = {};
    },
    // 新建工单-客户改变
    customerChange() {
      this.$set(this.dialogForm, "cartonOrderIds", []);
      this.$set(this.pullDownData, "cartonOrderList", []);
    },
    // 新建工单-包装工单
    selectVisible(value, orderName, labelName, origin) {
      if (value) {
        this.$refs.orderTableSelect.labelName = labelName;
        this.$refs.orderTableSelect.orderName = orderName;
        this.$refs.orderTableSelect.origin = origin;
        if (labelName!='员工选择') {
          this.$refs.orderTableSelect.parameter = {
            customerId: this.dialogForm.customerId,
            selectedRow: this.pullDownData.cartonOrderList.filter((item) =>
              this.dialogForm.cartonOrderIds.includes(item.id)
            ),
          };
        }
        this.$refs.orderTableSelect.openDialog();
      }
    },
    // 订单表格提交
    orderTableSubmit({ orderName, selectRow, labelName, origin }) {
      if (labelName=='员工选择') {        
        this.$set(this[origin], `${orderName + "Id"}`, selectRow.id);
        this.$set(this.pullDownData, `${orderName + "List"}`, [selectRow]);
      } else {
        this.$set(
          this.dialogForm,
          `${orderName + "Ids"}`,
          selectRow.map((item) => item.id)
        );
        this.$set(this.pullDownData, `${orderName + "List"}`, selectRow);
      }
    },
    // 添加产品--起始箱号
    beginIndexChange() {
      let { beginIndex, endIndex } = this.addDeviceForm;
      if (beginIndex > endIndex) {
        this.$set(this.addDeviceForm, "endIndex", beginIndex);
      }
    },
    // 添加产品--结束箱号
    endIndexChange() {
      let { beginIndex, endIndex } = this.addDeviceForm;
      if (beginIndex > endIndex) {
        this.$set(this.addDeviceForm, "beginIndex", endIndex);
      }
    },
    // 添加产品--零散箱号
    indexesInput(val) {
      let newVal = val.replace(/[^\d\n]/g, "");
      this.$set(this.addDeviceForm, "indexes", newVal);
    },
    // 添加产品--零散栈板
    palletIndexesInput(val) {
      let newVal = val.replace(/[^\d\n]/g, "");
      this.$set(this.addDeviceForm, "palletIndexes", newVal);
    },
    // 添加产品--零散栈板
    palletSnsInput(val) {
      this.$set(this.addDeviceForm, "palletSns", val);
    },
    // 添加产品--零散SN
    addDeviceSNInput(val) {
      this.$set(this.addDeviceForm, "sn", val);
    },
    // 表格数据排序
    sortChange({ prop, order }) {
      this.orderBy[0] = prop;
      if (order == "ascending") {
        this.desc = false;
      } else if (order == "descending") {
        this.desc = true;
      } else {
        this.desc = undefined;
        this.orderBy = [];
      }
      this.getShipmentOrderSearch();
    },
    // 页码改变
    currentChange(val) {
      this.pagination.currentPage = val;
      this.getShipmentOrderSearch();
    },
    // 页容量改变
    sizeChange(val) {
      this.pagination.currentPage = 1;
      this.pagination.pageSize = val;
      this.getShipmentOrderSearch();
    },
    // 表格列发货单号点击
    clickAllowSkip(row) {
      this.tabPaneValue = row.id;
      let tabPaneIds = this.tabPaneList.map((item) => item.id);
      if (tabPaneIds.includes(row.id)) {
        this.tabPaneList.splice(tabPaneIds.indexOf(row.id), 1, row);
      } else {
        this.tabPaneList.push(row);
      }
    },
    // 客户名称下拉
    async getCustomerList() {
      const res = await apiCustomerList();
      if (res.code == 0) {
        this.pullDownData.customerList = res.data;
      }
    },
    // 工单状态下拉
    async getShipmentStatusList() {
      const res = await apiShipmentStatusList();
      if (res.code == 0) {
        this.pullDownData.shipmentStatusList = res.data;
      }
    },
    callback() {
      this.getCustomerList();
      this.getShipmentStatusList();
    },
  },
  activated() {
    window.onresize = () => {
      document.querySelector(".contentBox").style.top =
        document.querySelector(".header").offsetHeight + "px";
    };
    if (this.tabPaneValue == "first") {
      this.getShipmentOrderSearch("", this.callback);
    } else {
      this.$nextTick(() => {
        if (this.cutDetail == "detail") {
          this.$refs.detailPage.getShipmentOrderDetail(this.callback);
        } else if (this.cutDetail == "devices") {
          this.$refs.devicesPage.getShipmentOrderDevices("", this.callback);
        }
      });
    }
  },
  deactivated() {
    window.onresize = null;
  },
};
</script>

<style lang="less" scoped>
  .downIcon {
    /deep/.el-icon-d-arrow-right {
      transform: rotateZ(90deg);
    }
  }
  .devicesDownloadDrop {
    transform: translateX(15px);
    .el-dropdown-menu__item {
      padding: 0 16px;
    }
    /deep/.popper__arrow {
      left: 46% !important;
    }
  }
  .icon-yiguoqi {
    margin-left: -3px;
    margin-right: 3px;
    color: #ff0000
  }
  .fail {
    color: #f56c6c;
  }
</style>